module.exports = __webpack_public_path__ + "static/profile_download-ddff6530c247f2aad233245dac968f69.png";